/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../id_pair';
import '../date';
import '../creator_details';
import '../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "RefundV1": {
                "fields": {
                  "refundIdPair": {
                    "type": ".squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.client.bills.RefundV1.State",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.client.ISO8601Date",
                    "id": 3,
                    "rule": "optional"
                  },
                  "refundReason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": ".squareup.client.bills.RefundV1.Amounts",
                    "id": 5,
                    "rule": "optional"
                  },
                  "tenderIdPair": {
                    "type": ".squareup.client.IdPair",
                    "id": 6,
                    "rule": "optional"
                  },
                  "creatorDetails": {
                    "type": ".squareup.client.CreatorDetails",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "UNKNOWN": 0,
                      "REQUESTED": 1,
                      "APPROVED": 2,
                      "COMPLETED": 3,
                      "REJECTED": 4,
                      "FAILED": 5
                    }
                  },
                  "Amounts": {
                    "fields": {
                      "refundedMoney": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.RefundV1 && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.RefundV1?.nested?.State && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.RefundV1?.nested?.Amounts) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RefundV1 @ squareup/client/bills/refund.proto at 18:1
 */
export const RefundV1 = $root.lookupType('squareup.client.bills.RefundV1');
fixType(RefundV1, {
  refundIdPair: {
    required: true
  },
  state: {
    required: true
  },
  createdAt: {
    required: true
  },
  amounts: {
    required: true
  },
  tenderIdPair: {
    required: true
  }
});
Builder.createAndAttachToType(RefundV1);
/**
 * SOURCE State @ squareup/client/bills/refund.proto at 21:3
 */
RefundV1.State = $root.lookupEnum('squareup.client.bills.RefundV1.State').values;
/**
 * SOURCE Amounts @ squareup/client/bills/refund.proto at 38:3
 */
RefundV1.Amounts = $root.lookupType('squareup.client.bills.RefundV1.Amounts');
fixType(RefundV1.Amounts, {
  refundedMoney: {
    required: true
  }
});
Builder.createAndAttachToType(RefundV1.Amounts);